import React, { useState, useEffect } from "react";
import { getPaginas } from "./../services/cmsServices"; // ajuste caminho se necessário

import {
  FaBars, FaTimes
} from "react-icons/fa";
const API_BASE = process.env.REACT_APP_API_CMS;
const SITE_URL = process.env.REACT_APP_SITE_URL;


const scrollToSection = (id) => {
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};

const TopNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const [links, setLinks] = useState([]);

  useEffect(() => {
    async function fetchLinks() {
      try {
        const paginas = await getPaginas();
        const ativos = paginas
          .filter(p => p.ativo && p.exibir_menu)
          .sort((a, b) => a.ordem - b.ordem)
          .map(p => ({
            id: p.slug,
            label: p.titulo,
            type: p.tipo_link === "pagina" ? "link" : p.tipo_link,
            href:
              p.tipo_link === "pagina"
                ? `/${p.slug}`
                : p.tipo_link === "arquivo"
                  ? `${API_BASE}/${p.arquivo}`
                  : p.link,
            target: ["externo", "arquivo"].includes(p.tipo_link) ? "_blank" : undefined
          }));
        setLinks(ativos);
      } catch (e) {
        console.error("Erro ao carregar menu:", e);
      }
    }

    fetchLinks();
  }, []);

  return (
    <header className="fixed top-0 w-full z-50 shadow bg-cinzaTransparente">
      {/* TopBar - mobile */}
      <div className="flex items-center justify-between px-4 py-2 bg-white lg:hidden">
        <button onClick={toggleMenu}>
          <FaBars size={22} className="text-gray-800" />
        </button>
        <div className="flex-1 flex justify-center">
          <a href='https://cf.coop.br/'  className="flex items-center">

            <img
              src="https://cf.coop.br/votacao-site/build/logo-cooperforte.png"
              alt="Logo COOPERFORTE"
              className="h-10"
            />
          </a>
        </div>
                  <a href="https://autoatendimento.cf.coop.br" target="_blank" className="flex items-center">
        <i className="bi bi-lock-fill text-xl text-[#f6b100]" />
        </a>
      </div>

      {/* TopBar - desktop */}
      <div className="hidden lg:flex justify-between items-center px-10 py-2 m-0">
          <a href='https://cf.coop.br/'  className="flex items-center">

          <img
            src="https://cf.coop.br/votacao-site/build/logo-cooperforte.png"
            alt="Logo COOPERFORTE"
            className="h-10"
          />
        </a>
        <div className="flex gap-4">
          <a
            href="https://www.cf.coop.br/index.php/para-se-associar/"
            target="_blank"
            className="bg-amarelo hover:bg-yellow-400 text-black text-sm font-semibold px-6 py-2 rounded inline-flex items-center justify-center"
          >
            <i className="bi bi-person-check-fill text-sm mr-2"></i>
            ASSOCIE-SE
          </a>
          <a
            href="https://autoatendimento.cf.coop.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amarelo hover:bg-yellow-400 text-black text-sm font-semibold px-6 py-2 rounded inline-flex items-center justify-center"
          >
            <i className="bi bi-lock-fill text-sm mr-2"></i>
            AUTOATENDIMENTO
          </a>
        </div>
      </div>

      {/* Menu horizontal desktop */}
      <nav className="hidden [@media(min-width:1024px)]:flex 
        bg-cinzaPadrao border-t border-gray-300 justify-left font-semibold text-black text-left text-[9px]    
        [@media(min-width:1050px)]:text-[10px]
        [@media(min-width:1189px)]:text-xs
        [@media(min-width:1350px)]:text-sm
        [@media(min-width:1580px)]:text-sm
        [@media(min-width:1700px)]:text-sm
      ">
        {links.map(({ id, label, type, href, target }, index) =>
          type === "scroll" ? (
            <button
              key={id}
              onClick={() => scrollToSection(id)}
              className={`px-2
              [@media(min-width:1050px)]:px-3
              [@media(min-width:1200px)]:px-4
              [@media(min-width:1500px)]:px-5
              [@media(min-width:1580px)]:px-6
              [@media(min-width:1700px)]:px-8
              py-5 border-r border-gray-300 hover:bg-gray-100
              truncate whitespace-nowrap overflow-hidden text-ellipsis
              ${index === links.length - 1 ? "border-r-0" : ""}`}
            >
              {label}
            </button>
          ) : (
            <a
              key={id}
              href={href}
              target={target}
              rel={target === "_blank" ? "noopener noreferrer" : undefined}
              className={`px-2
              [@media(min-width:1050px)]:px-3
              [@media(min-width:1200px)]:px-4
              [@media(min-width:1500px)]:px-5
              [@media(min-width:1580px)]:px-6
              [@media(min-width:1700px)]:px-8
              py-5 border-r border-gray-300 hover:bg-gray-100
              truncate whitespace-nowrap overflow-hidden text-ellipsis
              flex items-center ${index === links.length - 1 ? "border-r-0" : ""}`}
            >
              {label}
            </a>
          )
        )}
      </nav>

      {/* Menu lateral mobile */}
      <div className={`fixed top-0 left-0 h-full w-100 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-0 flex flex-col">
          <button onClick={closeMenu} className="self-end text-gray-600 p-4">
            <FaTimes />
          </button>

          {links.map(({ id, label, type, href, target }) =>
            type === "scroll" ? (
              <button
                key={id}
                onClick={() => {
                  scrollToSection(id);
                  closeMenu();
                }}
                className="ps-4 p-1 text-left font-semibold text-black text-[13px] border-b border-gray-400 hover:bg-gray-300 py-3"
              >
                {label}
              </button>
            ) : (
              <a
                key={id}
                href={href}
                target={target}
                rel={target === "_blank" ? "noopener noreferrer" : undefined}
                onClick={closeMenu}
                className="ps-4 p-1 block text-left font-semibold text-black text-[13px] border-b border-gray-400 hover:bg-gray-300 py-3"
              >
                {label}
              </a>
            )
          )}

          {/* Botões mobile: Associe-se e Autoatendimento */}
          <a
            href="https://www.cf.coop.br/index.php/para-se-associar/"
            target="_blank"
            className="bg-amarelo hover:bg-yellow-400 text-black font-semibold px-4 py-2 rounded text-center m-2"
          >
            <i className="bi bi-person-check-fill mr-2"></i>
            ASSOCIE-SE
          </a>
          <a
            href="https://autoatendimento.cf.coop.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amarelo hover:bg-yellow-400 text-black font-semibold px-4 py-2 rounded text-center m-2"
          >
            <i className="bi bi-lock-fill mr-2"></i>
            AUTOATENDIMENTO
          </a>
        </div>
      </div>

      {isOpen && (
        <div
          onClick={closeMenu}
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 lg:hidden"
        />
      )}
    </header>
  );
};

export default TopNav;
